import { get, writable } from "svelte/store";
import Analytics from "../../Analytics/Analytics";
import API from "../../API/API";
import AuthStore from "../../Auth/Store";
import LoadState from "../../Enums/LoadState";
import GeoHelper from "../../Helpers/GeoHelper";
import MapLayerGroup from "../../Map/Enums/MapLayerGroup";
import VisibilityState from "../../Map/Enums/VisibilityState";
import MapLayerManager from "../../Map/MapLayerManager";
import { Paint } from "../../Map/MapLayerStyles";
import MapStore from "../../Map/Store";
import HydrographicChart from "./HydrographicChart";

// TODO: this func is same in MaritimeBoundaries store
const initLayerData = () => {
	return {
		layers: [],
		visible: writable(true)
	};
};

const HydrographicChartStore = {
	config: {

	},
	meta: {
		loadState: writable(LoadState.INIT),
		layers: [],
		layerData: {
			ukho_charts_borders: initLayerData()
		},
		visible: writable(false),
		lastUpdated: writable(0)
	},
	filters: {
		filterString: writable("")
	},
	results: {
		charts: writable([])
	},
	spatialQuery: {
		meta: {
			loadState: writable(LoadState.INIT),
			error: writable("")
		},
		results: {
			charts: writable([])
		}
	},
	actions: {
		init: () => {
			if (get(HydrographicChartStore.meta.loadState) !== LoadState.INIT) {
				return;
			}
			HydrographicChartStore.meta.loadState.set(LoadState.LOADING);
			console.log("Loading Charts...");

			const map = MapStore.helpers.getMap();

			API.get("charts").then((results) => {
				const charts = [];
				for (let i = 0; i < results.length; i++) {
					const chart = new HydrographicChart(results[i]);
					charts.push(chart);
				}

				HydrographicChartStore.results.charts.set(charts);

				// TODO: move this.
				MapStore.helpers.addDataLayer("ukho_charts_borders", "line", {}, Paint.borderLine, GeoHelper.emptyGeoJson(), HydrographicChartStore.meta.layers);
				HydrographicChartStore.meta.layerData.ukho_charts_borders.layers.push("ukho_charts_borders");

				HydrographicChartStore.actions.updateLayerGroup();

				HydrographicChartStore.meta.loadState.set(LoadState.LOADED);
				HydrographicChartStore.meta.lastUpdated.set(Date.now());
			});
		},
		updateLayerGroup: () => {
			const layers = ["ukho_charts_borders"];
			const charts = get(HydrographicChartStore.results.charts);
			for (let i = 0; i < charts.length; i++) {
				const loaded = get(charts[i].loadState) === LoadState.LOADED;
				if (loaded) {
					layers.push(charts[i].layerId);
				}
			}
			MapLayerManager.addLayerGroup(MapLayerGroup.NAUTICAL_CHARTS, layers, layers);
		},

		updateVisibility: () => {
			const map = MapStore.helpers.getMap();
			if (map) {
				if (get(HydrographicChartStore.meta.loadState) !== LoadState.LOADED) {
					return;
				}
				HydrographicChartStore.actions.updateLayerGroup();

				const visible = get(HydrographicChartStore.meta.visible);
				const charts = get(HydrographicChartStore.results.charts);
				for (let i = 0; i < charts.length; i++) {
					const chartVisibble = get(charts[i].visible);
					const loaded = get(charts[i].loadState) === LoadState.LOADED;
					if (loaded) {
						map.setLayoutProperty(charts[i].layerId, "visibility", (visible && chartVisibble) ? VisibilityState.VISIBLE : VisibilityState.NONE);
					}
				}
			}
		},
		updateBoundsFeatureCollection: () => {
			const featureCollection = GeoHelper.emptyGeoJson();
			if (get(HydrographicChartStore.meta.visible)) {
				const charts = get(HydrographicChartStore.results.charts);
				for (let i = 0; i < charts.length; i++) {
					featureCollection.features.push(charts[i].boundsFeature);
				}
			}
			const map = MapStore.helpers.getMap();
			if (map) {
				const sourceBorders = map.getSource("ukho_charts_borders");
				if (sourceBorders) {
					sourceBorders.setData(featureCollection);
				}
			}
		},

		loadSingle: (chartModelObject) => {
			Analytics.event("load_" + chartModelObject.file, { category: "Nautical Charts (Beta)", username: get(AuthStore.userInfo).username, id: chartModelObject.file });

			chartModelObject.loadState.set(LoadState.LOADING);
			HydrographicChartStore.meta.lastUpdated.set(Date.now());

			// const layerType = chartModelObject.type.toLowerCase();
			API.get("charts/image?id=" + chartModelObject.file).then((result) => {
				chartModelObject.image = "data:image/png;base64, " + result.image_b64.substr(2, result.image_b64.length - 3);
				chartModelObject.loadState.set(LoadState.LOADED);

				HydrographicChartStore.actions.updateBoundsFeatureCollection();
				HydrographicChartStore.actions.updateVisibility();
				HydrographicChartStore.meta.lastUpdated.set(Date.now());
			});
		},

		spatialQuery: (lngLatArray) => {
			HydrographicChartStore.spatialQuery.meta.error.set("");
			HydrographicChartStore.spatialQuery.meta.loadState.set(LoadState.LOADING);

			const results = [];
			const charts = get(HydrographicChartStore.results.charts);

			for (let i = 0; i < charts.length; i++) {
				const chart = charts[i];
				// if (chart.bounds.contains(lngLatArray)) {
				if (chart.left <= lngLatArray[0] && chart.right >= lngLatArray[0] &&
					chart.top >= lngLatArray[1] && chart.bottom <= lngLatArray[1]) {
					results.push(charts[i]);
				}
			}
			console.log("spatialQuery", results);

			HydrographicChartStore.spatialQuery.results.charts.set(results);
			HydrographicChartStore.spatialQuery.meta.loadState.set(LoadState.LOADED);
		}
	}
};

export default HydrographicChartStore;
